import { UserRole, UserSubscriptionTypes } from './constants';

export function getRoleAccessCheckLib() {
  return {
    hasAdminOrSuperiorRoleInApps(currentUserRoles) {
      return (
        currentUserRoles &&
        (currentUserRoles.apps === UserRole.ADMIN ||
          currentUserRoles.apps === UserRole.SUPER_ADMIN)
      );
    },
    hasAdminOrSuperiorRoleInGoals(currentUserRoles) {
      return currentUserRoles && currentUserRoles.okr === UserRole.ADMIN;
    },
    hasAdminOrSuperiorRoleInPerf(currentUserRoles) {
      return currentUserRoles && currentUserRoles.perf === UserRole.ADMIN;
    },
    hasAdminOrSuperiorRoleInPeople(currentUserRoles) {
      return (
        currentUserRoles &&
        (currentUserRoles.people === UserRole.SUPER_HR ||
          currentUserRoles.people === UserRole.ADMIN)
      );
    },

    hasSuperHrOrSuperiorRoleInPeople(currentUserRoles) {
      return (
        currentUserRoles &&
        (currentUserRoles.people === UserRole.SUPER_HR ||
          currentUserRoles.people === UserRole.SUPER_ADMIN)
      );
    },

    hasAdminOrSuperiorRoleInOneonOne(currentUserRoles) {
      return (
        currentUserRoles && currentUserRoles.communicate === UserRole.ADMIN
      );
    },

    hasSlackIntegrationAccess(currentUserRoles) {
      return (
        currentUserRoles &&
        (this.hasAdminOrSuperiorRoleInGoals(currentUserRoles) ||
          this.hasAdminOrSuperiorRoleInPeople(currentUserRoles) ||
          this.hasAdminOrSuperiorRoleInApps(currentUserRoles) ||
          this.hasAdminOrSuperiorRoleInPerf(currentUserRoles) ||
          this.hasAdminOrSuperiorRoleInOneonOne(currentUserRoles))
      );
    },
    hasModuleAccessSettingAccess(currentUserRoles, orgAccessibleModules) {
      return (
        currentUserRoles &&
        orgAccessibleModules &&
        orgAccessibleModules?.length > 1 &&
        orgAccessibleModules?.includes(UserSubscriptionTypes.ADVANCED) &&
        this.hasAdminOrSuperiorRoleInGoals(currentUserRoles)
      );
    },
    hasAdminOrSuperiorRole(currentUserRoles) {
      return currentUserRoles
        ? this.hasAdminOrSuperiorRoleInApps(currentUserRoles) ||
            this.hasAdminOrSuperiorRoleInGoals(currentUserRoles) ||
            this.hasAdminOrSuperiorRoleInPerf(currentUserRoles) ||
            this.hasAdminOrSuperiorRoleInPeople(currentUserRoles)
        : false;
    }
  };
}

export const RoleAccessCheckLib = getRoleAccessCheckLib();

export function getModuleAccessCheckLib() {
  const isModulesValid = modules => modules && modules?.length > 0;
  const hasOkrModuleAccess = modules =>
    isModulesValid(modules) &&
    (modules?.includes(UserSubscriptionTypes.ADVANCED) ||
      modules?.includes(UserSubscriptionTypes.BASIC));

  const hasAdvancedOkrAccess = modules =>
    isModulesValid(modules) &&
    modules?.includes(UserSubscriptionTypes.ADVANCED);

  const hasBasicOkrAccess = modules =>
    isModulesValid(modules) && modules?.includes(UserSubscriptionTypes.BASIC);

  const hasReviewModuleAccess = modules =>
    isModulesValid(modules) && modules?.includes('REVIEW');

  const hasFeedbackModuleAccess = modules =>
    isModulesValid(modules) && modules?.includes('FEEDBACK');

  // named it v1 to distinguis from the already declare function
  const hasSurveyModuleAccess = modules =>
    isModulesValid(modules) && modules?.includes('SURVEY');

  const hasAmaModuleAccess = modules =>
    isModulesValid(modules) && modules?.includes('AMA');

  const hasSurveyModuleAccessAndIsAdminOrAbove = (modules, userRoles) =>
    hasSurveyModuleAccess(modules) &&
    RoleAccessCheckLib.hasAdminOrSuperiorRoleInPeople(userRoles);

  const hasSurveyModuleAccessAndIsSuperHrOrAbove = (modules, userRoles) =>
    hasSurveyModuleAccess(modules) &&
    RoleAccessCheckLib.hasSuperHrOrSuperiorRoleInPeople(userRoles);
  return {
    isModulesValid,
    hasOkrModuleAccess,
    hasAdvancedOkrAccess,
    hasBasicOkrAccess,
    hasReviewModuleAccess,
    hasFeedbackModuleAccess,
    hasSurveyModuleAccess,
    hasAmaModuleAccess,
    hasSurveyModuleAccessAndIsAdminOrAbove,
    hasSurveyModuleAccessAndIsSuperHrOrAbove
  };
}

export function checkIfSubscriptionCallIsNecessary(
  accessibleModules,
  userRoles
) {
  const roleAccessLib = RoleAccessCheckLib;
  const moduleAccessCheckLib = getModuleAccessCheckLib();
  return (
    accessibleModules?.length &&
    moduleAccessCheckLib.hasSurveyModuleAccess(accessibleModules) &&
    roleAccessLib.hasAdminOrSuperiorRoleInPeople(userRoles)
  );
}
